export const PRIORITIES = ['none', 'M', '3', '2', '1', 'X'];

export const PRIORITY_FILTER_VALUES = PRIORITIES.filter((priority) => priority !== 'none');

function getPriorityIndex(p) {
  return PRIORITIES.findIndex((x) => x === p);
}

export function comparePriority(a, b) {
  return getPriorityIndex(b) - getPriorityIndex(a);
}
